module.exports = __webpack_public_path__ + "0b7e99b7d8a3f655bcced6d0c996302d.png";